/* ICR product page (Kida Digital, Oct 2026) */
(function () {
  function init(root) {
    if (root.dataset.icrReady) return;
    root.dataset.icrReady = '1';
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    // Breadcrumb: follow the shopper's own path (last collection browsed), if this product is in it
    var crumbs = $('[data-icr-crumbs]');
    if (crumbs && !crumbs.dataset.urlContext) {
      try {
        var last = JSON.parse(window.sessionStorage.getItem('icr:lastCollection') || 'null');
        var ok = ',' + (crumbs.dataset.handles || '');
        if (last && last.handle && ok.indexOf(',' + last.handle + ',') > -1) {
          var link = crumbs.querySelector('[data-icr-crumb]');
          link.href = last.url; link.textContent = last.title; link.hidden = false;
          crumbs.querySelector('[data-icr-crumb-sep]').hidden = false;
        }
      } catch (e) {}
    }

    // Gallery: scroll-snap strip + thumbs + dots
    var slides = $('[data-icr-slides]');
    var thumbs = $$('[data-icr-thumb]');
    var dots = $$('.icr-pdp__dots span');
    function slideEls() { return slides ? Array.prototype.slice.call(slides.children) : []; }
    function goTo(i, smooth) {
      var els = slideEls();
      if (!slides || !els[i]) return;
      slides.scrollTo({ left: els[i].offsetLeft - slides.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    function mark(i) {
      thumbs.forEach(function (t, n) { if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    }
    function goToMedia(id) {
      var els = slideEls();
      for (var i = 0; i < els.length; i++) if (String(els[i].dataset.mediaId) === String(id)) return goTo(i);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    if (slides) {
      var tick;
      slides.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () { mark(Math.round(slides.scrollLeft / slides.clientWidth)); }, 60);
      }, { passive: true });
      slides.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var i = Math.round(slides.scrollLeft / slides.clientWidth) + (e.key === 'ArrowRight' ? 1 : -1);
        goTo(Math.max(0, Math.min(slideEls().length - 1, i)));
        e.preventDefault();
      });
    }

    // Quantity
    $$('[data-icr-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = root.querySelector('.icr-qty__input');
        var n = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.icrQty, 10);
        var max = parseInt(input.max, 10);
        input.value = Math.max(1, max ? Math.min(max, n) : n);
        updateBulk();
      });
    });

    // Variants
    var data = [];
    try { data = JSON.parse(($('[data-icr-variants]') || {}).textContent || '[]'); } catch (e) {}
    var idInput = $('[data-icr-variant-id]');
    var priceEl = $('[data-icr-pdp-price]');
    var addBtn = $('[data-icr-pdp-add]');
    var addLabel = $('[data-icr-add-label]');
    var stickyPrice = $('[data-icr-sticky-price]');
    var stickyBtn = document.querySelector('[data-icr-sticky-add]');
    var stickyLabel = document.querySelector('[data-icr-sticky-label]');
    var stock = $('[data-icr-stock]');
    var stockText = $('[data-icr-stock-text]');
    var saleBadge = $('[data-icr-sale-badge]');
    var optionInputs = $$('[data-icr-opt]');

    function selected() {
      var out = [];
      optionInputs.forEach(function (i) { if (i.checked) out[+i.dataset.icrOpt] = i.value; });
      return out;
    }
    function find(opts) {
      for (var i = 0; i < data.length; i++) {
        var v = data[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function refreshAvailability(opts) {
      optionInputs.forEach(function (input) {
        var idx = +input.dataset.icrOpt;
        var test = opts.slice(); test[idx] = input.value;
        var v = find(test);
        input.closest('.icr-pdp__val').classList.toggle('is-soldout', !v || !v.available);
      });
      $$('[data-icr-opt-val]').forEach(function (el, i) { el.textContent = opts[i] || ''; });
    }
    var baseLabel = (addBtn && addBtn.dataset.label) || 'Add to cart';
    var soldLabel = (addBtn && addBtn.dataset.soldout) || 'Sold out';
    var priceInLabel = addBtn && addBtn.dataset.labelPrice === 'true';
    function setButtons(available, label, price) {
      [addBtn, stickyBtn].forEach(function (b) { if (b) b.disabled = !available; });
      if (addLabel) addLabel.textContent = available && priceInLabel && price ? label + ' · ' + price : label;
      if (stickyLabel) stickyLabel.textContent = label;
      updateBulk();
    }
    function apply(v) {
      curV = v;
      if (!v) { setButtons(false, 'Unavailable'); return; }
      if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (priceEl) {
        var keep = Array.prototype.slice.call(priceEl.querySelectorAll('small, [data-icr-keep]'));
        priceEl.innerHTML = v.price_html;
        keep.forEach(function (k) { priceEl.appendChild(k); });
      }
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (saleBadge) saleBadge.hidden = !v.sale;
      setButtons(v.available, v.available ? baseLabel : soldLabel, v.price);
      if (stock) {
        var th = parseInt(stock.dataset.threshold, 10) || 0;
        var low = v.qty !== null && v.qty > 0 && v.qty <= th;
        stock.hidden = !low;
        if (low && stockText) stockText.textContent = 'Just ' + v.qty + ' left. Order soon!';
      }
      if (v.media) goToMedia(v.media);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      document.dispatchEvent(new CustomEvent('icr:variant-change', { detail: { variant: v } }));
    }
    optionInputs.forEach(function (i) {
      i.addEventListener('change', function () { var o = selected(); refreshAvailability(o); apply(find(o)); });
    });
    if (optionInputs.length) refreshAvailability(selected());

    // Volume discount tiers: highlight the tier for (qualifying items in cart + this quantity),
    // show the price each for the selected size, and put the discounted total in the button
    var curV = null;
    (function () {
      var id = idInput ? parseInt(idInput.value, 10) : 0;
      for (var i = 0; i < data.length; i++) if (data[i].id === id) curV = data[i];
    })();
    var bulk = $('[data-icr-bulk]'), bulkData = null;
    try { if (bulk) bulkData = JSON.parse(bulk.querySelector('[data-icr-bulk-data]').textContent); } catch (e) { bulkData = null; }
    var bulkHint = $('[data-icr-bulk-hint]');
    function money2(cents) { return '$' + (Math.max(0, cents) / 100).toFixed(2); }
    function bulkEach(cents, t) {
      return bulkData.type === 'fixed' ? Math.max(0, cents - Math.round(t.val * 100)) : Math.round(cents * (100 - t.val) / 100);
    }
    function bulkTier(total) {
      var t = bulkData.tiers[0];
      bulkData.tiers.forEach(function (x) { if (total >= x.min) t = x; });
      return t;
    }
    function qtyNow() {
      var q = $('.icr-qty__input');
      return q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
    }
    function updateBulk() {
      if (!bulkData || !curV) return;
      var qty = qtyNow(), total = bulkData.inCart + qty, t = bulkTier(total);
      $$('[data-icr-tier]').forEach(function (b) {
        var tier = bulkData.tiers[+b.dataset.icrTier];
        if (!tier) return;
        var on = tier === t;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', String(on));
        var p = b.querySelector('[data-icr-tier-price]');
        if (p) p.textContent = money2(bulkEach(curV.cents, tier)) + ' each';
      });
      if (addLabel && curV.available) {
        addLabel.textContent = (qty > 1 ? 'Add ' + qty + ' to cart' : baseLabel) + ' · ' + money2(qty * bulkEach(curV.cents, t));
      }
      if (bulkHint) {
        var next = null;
        bulkData.tiers.forEach(function (x) { if (!next && x.min > total) next = x; });
        var parts = [];
        if (bulkData.inCart > 0) parts.push(bulkData.inCart + ' already in your cart count toward this.');
        if (next) {
          var save = bulkData.type === 'fixed' ? money2(Math.round(next.val * 100)) + ' each' : next.val + '%';
          parts.push('Add ' + (next.min - total) + ' more to save ' + save + '.');
        } else if (t.val > 0) {
          parts.push('You’re getting our best price.');
        }
        bulkHint.textContent = parts.join(' ');
      }
    }
    if (bulkData) {
      $$('[data-icr-tier]').forEach(function (b) {
        b.addEventListener('click', function () {
          var tier = bulkData.tiers[+b.dataset.icrTier];
          var q = $('.icr-qty__input');
          if (!tier || !q) return;
          var want = Math.max(1, tier.min - bulkData.inCart);
          var max = parseInt(q.max, 10);
          q.value = max ? Math.min(max, want) : want;
          updateBulk();
        });
      });
      var qIn = $('.icr-qty__input');
      if (qIn) ['input', 'change'].forEach(function (ev) { qIn.addEventListener(ev, updateBulk); });
      var refreshCart = function () {
        if (!document.body.contains(root)) return;
        fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var n = 0;
            cart.items.forEach(function (it) {
              if (it.product_id === bulkData.pid || bulkData.ids.indexOf(it.product_id) > -1) n += it.quantity;
            });
            bulkData.inCart = n;
            var q = $('.icr-qty__input');
            if (q) q.value = 1;
            updateBulk();
          }).catch(function () {});
      };
      document.addEventListener('icr:cart-added', refreshCart);
      if (window.subscribe && window.PUB_SUB_EVENTS) {
        try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== 'icr-card') refreshCart(); }); } catch (e) {}
      }
      updateBulk();
    }

    // Sticky add to cart (mobile): show once the main button scrolls away
    var sticky = document.querySelector('[data-icr-sticky]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(addBtn);
    }

    // Free delivery bar
    var ship = $('[data-icr-ship]');
    function money(cents) {
      var n = cents / 100;
      return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
    }
    function updateShip() {
      if (!ship) return;
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var goal = parseInt(ship.dataset.goal, 10);
          var left = goal - cart.total_price;
          var pct = Math.min(100, Math.round(cart.total_price * 100 / goal));
          var text = ship.querySelector('[data-icr-ship-text]');
          text.innerHTML = left > 0
            ? '<b>' + money(left) + ' away from free delivery</b> on orders over ' + money(goal)
            : '<b>You’ve unlocked free delivery!</b>';
          ship.querySelector('[data-icr-ship-fill]').style.width = pct + '%';
          ship.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', pct);
        }).catch(function () {});
    }
    document.addEventListener('icr:cart-added', updateShip);
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== 'icr-card') updateShip(); }); } catch (e) {}
    }

    // Review snippet: rotate quotes, pause on hover/focus, respect reduced motion
    var rs = $('[data-icr-rsnip]');
    if (rs) {
      var items = Array.prototype.slice.call(rs.querySelectorAll('.icr-pdp__rsnip-item'));
      var rdots = Array.prototype.slice.call(rs.querySelectorAll('[data-icr-rsnip-go]'));
      var cur = 0, paused = false;
      var show = function (n) {
        cur = (n + items.length) % items.length;
        items.forEach(function (it, k) { it.hidden = k !== cur; });
        rdots.forEach(function (d, k) { d.classList.toggle('is-on', k === cur); if (k === cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      };
      rdots.forEach(function (d) { d.addEventListener('click', function () { show(+d.dataset.icrRsnipGo); }); });
      ['mouseenter', 'focusin'].forEach(function (ev) { rs.addEventListener(ev, function () { paused = true; }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { rs.addEventListener(ev, function () { paused = false; }); });
      if (items.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        setInterval(function () { if (!paused && !document.hidden) show(cur + 1); }, parseInt(rs.dataset.interval, 10) || 4000);
      }
    }

    // Gift card recipient: fields only submit when the box is ticked
    var giftToggle = $('[data-icr-gift-toggle]');
    if (giftToggle) {
      var giftFields = $('[data-icr-gift-fields]');
      var syncGift = function () {
        giftFields.hidden = !giftToggle.checked;
        giftFields.querySelectorAll('input, textarea').forEach(function (f) { f.disabled = !giftToggle.checked; });
      };
      var off = $('[data-icr-gift-offset]');
      if (off) off.value = new Date().getTimezoneOffset();
      giftToggle.addEventListener('change', syncGift);
      syncGift();
    }

    // Quantity cap (classes: can't book more places than are left)
    var qtyInput = $('.icr-qty__input');
    if (qtyInput && qtyInput.max) {
      qtyInput.addEventListener('change', function () { var m = parseInt(qtyInput.max, 10); if (+qtyInput.value > m) qtyInput.value = m; });
    }

    // Pairs well with (Search & Discovery complementary products)
    var pairs = $('[data-icr-pairs]');
    if (pairs) {
      fetch(pairs.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('.icr-pairs');
        if (list && list.children.length) {
          pairs.querySelector('[data-icr-pairs-list]').appendChild(list);
          pairs.hidden = false;
        }
      }).catch(function () {});
    }
  }

  function boot() { document.querySelectorAll('[data-icr-pdp]').forEach(init); }
  window.ICRpdpBoot = boot;

  // Combined listing: switch to a connected product without a full page load
  function runScripts(root) {
    root.querySelectorAll('script').forEach(function (old) {
      if (old.src || (old.type && old.type !== 'text/javascript' && old.type !== 'module')) return;
      var s = document.createElement('script');
      if (old.type) s.type = old.type;
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }
  // Globo setting "Keep the shopper's place": if we fall back to a full page load, reopen at the same spot
  function go(url) {
    try { window.sessionStorage.setItem('icr:clPlace', JSON.stringify({ path: new URL(url, location.href).pathname, y: window.scrollY })); } catch (e) {}
    window.location.href = url;
  }
  try {
    var place = JSON.parse(window.sessionStorage.getItem('icr:clPlace') || 'null');
    if (place && place.path === location.pathname) {
      window.sessionStorage.removeItem('icr:clPlace');
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      var restore = function () { window.scrollTo(0, place.y); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore); else restore();
    }
  } catch (e) {}

  function swapParts() {
    var pdp = document.querySelector('[data-icr-pdp]');
    var mainSec = pdp && pdp.closest('.shopify-section');
    if (!mainSec || !window.fetch) return null;
    var secs = Array.prototype.slice.call(mainSec.parentElement.children).filter(function (el) {
      return el.classList.contains('shopify-section');
    }).slice(0, 5);
    return { pdp: pdp, mainSec: mainSec, secs: secs, ids: secs.map(function (el) { return el.id.replace('shopify-section-', ''); }) };
  }
  function sectionsUrl(url, ids) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'sections=' + encodeURIComponent(ids.join(',')); }
  // Globo setting "Preload linked product pages on hover"
  var preloaded = {};
  function preload(link) {
    var parts = swapParts();
    if (!parts || preloaded[link.href]) return;
    preloaded[link.href] = fetch(sectionsUrl(link.href, parts.ids))
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .catch(function (err) { delete preloaded[link.href]; throw err; });
    preloaded[link.href].catch(function () {});
  }
  var hoverTimer;
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('[data-icr-cl]');
    if (!sw || sw.getAttribute('aria-current') === 'true') return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { preload(sw); }, 65);
  });
  document.addEventListener('touchstart', function (e) {
    var sw = e.target.closest && e.target.closest('[data-icr-cl]');
    if (sw && sw.getAttribute('aria-current') !== 'true') preload(sw);
  }, { passive: true });

  function swapTo(link) {
    var url = link.href;
    var parts = swapParts();
    if (!parts) { go(url); return; }
    var pdp = parts.pdp, mainSec = parts.mainSec, secs = parts.secs, ids = parts.ids;
    pdp.classList.add('is-swapping');
    var req = preloaded[url] || fetch(sectionsUrl(url, ids)).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    delete preloaded[url];
    req
      .then(function (json) {
        if (!json[ids[secs.indexOf(mainSec)]]) throw new Error('no section');
        secs.forEach(function (el, i) {
          var html = json[ids[i]];
          if (!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[id="' + el.id + '"]') || tmp.firstElementChild;
          if (!fresh) return;
          el.parentNode.replaceChild(fresh, el);
          runScripts(fresh);
        });
        window.history.pushState({ icrCl: true }, '', url);
        var shopName = pdp.dataset.shop || '';
        if (link.dataset.title) document.title = link.dataset.title + (shopName ? ' – ' + shopName : '');
        document.documentElement.dataset.icrSwapped = '1';
        boot();
        var cur = document.querySelector('[data-icr-cl][aria-current="true"]');
        if (cur) cur.focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('icr:product-swapped', { detail: { url: url } }));
      })
      .catch(function () { go(url); });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var sw = e.target.closest('[data-icr-cl]');
    if (sw) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      e.preventDefault();
      if (sw.getAttribute('aria-current') !== 'true') swapTo(sw);
      return;
    }
    var more = e.target.closest('[data-icr-cl-more]');
    if (more) {
      var list = more.parentNode.querySelector('[data-icr-cl-list]');
      if (!more.dataset.label) more.dataset.label = more.textContent;
      var open = !list.classList.toggle('is-collapsed');
      more.setAttribute('aria-expanded', String(open));
      more.textContent = open ? 'Show fewer' : more.dataset.label;
      return;
    }
    // Judge.me's full widget doesn't re-initialise after a swap: load the page properly instead
    if (document.documentElement.dataset.icrSwapped && e.target.closest('.icr-prev__all summary, [data-icr-write]')) {
      e.preventDefault();
      window.location.reload();
    }
  });
  window.addEventListener('popstate', function () {
    if (document.documentElement.dataset.icrSwapped) window.location.reload();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();